/* @flow */

import * as React from 'react';
import styled from 'styled-components';

import FlexBox from '../FlexBox';
import { formatNumber } from '../../utils/number';
import { getLabel } from '../../utils/i18n';

const FEE_RATE_DECIMAL_PLACE = 4;

const FeeBox = styled(FlexBox)`
  font-size: 12px;
  padding-right: 5px;
`;

const FeeVal = styled.div`
  margin-left:4px;
`;

const NormalVal = styled.span`
  margin-left:3px;
`;

const DiscountVal = styled.span`
  color: ${({ theme }) => theme.fontColor2};
  text-decoration: line-through;
`;

const DelimiterBox = styled.span`
  padding: 0 6px;
`;


type ComponentProps = {
  userInfo: Object,
  i18n: Object,
  userTradeFee: Object,
  userGasRate: number,
  isDiscount: boolean,
  delimiter: string,
};

export default
class UserFees extends React.PureComponent<ComponentProps> {
  static defaultProps = {
    i18n: {},
    isDiscount: false,
    delimiter: ' ',
  }

  _getUserTradeFeeRate = () => {
    const { userTradeFee, userGasRate } = this.props;
    const { buyMakerCommission, buyTakerCommission } = userTradeFee;
    const userTradeFeeRate = {
      takerRate: '–',
      takerRateWithBurning: '–',
      makerRate: '–',
      makerRateWithBurning: '–',
    };
    if (buyTakerCommission !== undefined && buyTakerCommission !== '--') {
      userTradeFeeRate.takerRate = `${formatNumber(buyTakerCommission * 100, FEE_RATE_DECIMAL_PLACE)}%`;
      userTradeFeeRate.takerRateWithBurning = `${formatNumber(buyTakerCommission * 100 * (1 - userGasRate), FEE_RATE_DECIMAL_PLACE)}%`;
    }
    if (buyMakerCommission !== undefined && buyMakerCommission !== '--') {
      userTradeFeeRate.makerRate = `${formatNumber(buyMakerCommission * 100, FEE_RATE_DECIMAL_PLACE)}%`;
      userTradeFeeRate.makerRateWithBurning = `${formatNumber(buyMakerCommission * 100 * (1 - userGasRate), FEE_RATE_DECIMAL_PLACE)}%`;
    }
    return userTradeFeeRate;
  }

  render() {
    const {
      i18n, userInfo, isDiscount, delimiter,
    } = this.props;
    const { commissionStatus } = userInfo.userData || {};
    const {
      takerRate,
      takerRateWithBurning,
      makerRate,
      makerRateWithBurning,
    } = this._getUserTradeFeeRate();
    return (
      <FeeBox>
        <span>{getLabel('exchange-TradeOrdersTable-Fee', i18n)}:</span>
        <FeeVal>
          Taker &nbsp;(
          {isDiscount && commissionStatus === 1 && <DiscountVal>{takerRate}</DiscountVal>}
          <NormalVal>{commissionStatus === 1 ? takerRateWithBurning : takerRate}</NormalVal>
          )
          {delimiter && <DelimiterBox>{delimiter}</DelimiterBox>}
          Maker &nbsp;(
          {isDiscount && commissionStatus === 1 &&
            <DiscountVal commissionStatus={commissionStatus}>{makerRate}</DiscountVal>}
          <NormalVal>{commissionStatus === 1 ? makerRateWithBurning : makerRate}</NormalVal>
          )
        </FeeVal>
      </FeeBox>
    );
  }
}
